'use strict'

exports.SERVICE_TAG = '_ipfs-discovery._udp'
exports.SERVICE_TAG_LOCAL = `${exports.SERVICE_TAG}.local`
exports.MULTICAST_IP = '224.0.0.251'
exports.MULTICAST_PORT = 5353
